import camelCase from 'lodash/camelCase';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareSummaryEmbedRoute } from '@atlassian/jira-router-routes-software-summary-embed-routes/src/softwareSummaryEmbedRoute.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { summarySoftwareEmbedEntrypoint } from '@atlassian/jira-spa-apps-summary/software-embed/entrypoint.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';

const summarySoftwareEmbedPageEntrypoint = createChromelessEntryPoint({
	main: summarySoftwareEmbedEntrypoint,
});

export const softwareSummaryEmbedRouteEntry = createEntry(softwareSummaryEmbedRoute, () => ({
	group: 'software',
	ufoName: 'next-gen-summary-embed',
	layout: chromelessLayout,

	resources: [
		...getNavigationResources(),
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],

	meta: {
		reporting: {
			id: 'software-summary-embed',
			packageName: camelCase('software-summary-embed'),
			teamName: 'Helios - HeadCoach',
		},
	},

	entryPoint: () => summarySoftwareEmbedPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-software-summary-embed-entries/src/softwareSummaryEmbedRouteEntry.tsx',
			whichExportToUse: 'softwareSummaryEmbedRouteEntry',
		},

		enabled: true,
	},
}));
